'use strict';

/*@ngInject*/
module.exports = function($rootScope, $scope, $state, $stateParams, $translate, $filter, $window, rssFeed) {
	$rootScope.title = $translate.instant('pages.titles.newsroom');

	var postUrl = decodeURIComponent($stateParams.link);

	var formatDate = function(dateString) {
		var date = new Date(dateString);
		var format = $translate.instant('templates.dateformat');

		return $filter('date')(date, format);
	};

	if (postUrl) {
		postUrl += $state.current.data.postFeedSuffix;
		rssFeed.load(postUrl, 1)
			.then(function(response) {
				console.log(response);
				if (!response.data) {
					console.error(response.data);
				}
				else {

					$scope.entry = response.data.items[0];
					$rootScope.title = $scope.entry.title;

					// format date
					$scope.entry.formattedDate = formatDate($scope.entry.pubDate.substring(0,10));	


					// $scope.entry = response.data.responseData.feed.entries[0];
					// $rootScope.title = $scope.entry.title;

					// // format date
					// $scope.entry.formattedDate = formatDate($scope.entry.publishedDate);	
				}				
			});
	}

	$scope.back = function() {
		$window.history.back();
	};

	$window.scrollTo(0,0);
};